var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cart__item" }, [
    _c(
      "a",
      {
        staticClass: "image-wrapper",
        attrs: { href: _vm.product.attributes.detail_url }
      },
      [
        _c("div", { staticClass: "filter" }),
        _vm._v(" "),
        _c("img", { attrs: { src: _vm.product.attributes.pic_url } })
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "cart__item__info" }, [
      _c(
        "a",
        {
          staticClass: "cart__item__name",
          attrs: { href: _vm.product.attributes.detail_url }
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.product.attributes.name) +
              "\n        "
          )
        ]
      ),
      _vm._v(" "),
      _vm.product.attributes.salable === false
        ? _c("div", { staticClass: "not-saleable" }, [
            _vm._v(_vm._s(_vm.strings["price_error"]))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "cart-item-code" }, [
        _vm._v(_vm._s(_vm.product.attributes.product_code))
      ]),
      _vm._v(" "),
      !_vm.product.attributes.is_giftcard
        ? _c("div", { staticClass: "cart-item-color" }, [
            _vm._v("\n            " + _vm._s(_vm.strings["color"]) + ": "),
            _c("span", { staticClass: "details-value" }, [
              _vm._v(_vm._s(_vm.product.attributes.description_color))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "cart-item-size" }, [
        _vm._v("\n            " + _vm._s(_vm.strings["size"]) + ": "),
        _c("span", { staticClass: "details-value" }, [
          _vm._v(_vm._s(_vm.product.attributes.size))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cart__item__prices" }, [
      _c("div", { staticClass: "item__quantity" }, [
        _c(
          "button",
          {
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("remove")
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 10 2",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M0.833496 0.0777508H4.51621H4.8373L5.4057 0.0776367L6.13109 0.0777508H9.8335V1.63355H6.13109H5.66148L4.8373 1.63348L4.51621 1.63355H0.833496V0.0777508Z",
                    fill: "black"
                  }
                })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "quantity-value" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.product.quantity) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("add")
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 10 10",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M0.42627 4.07757H4.10898V0.237305H5.72386V4.07757H9.42627V5.63337H5.72386V9.51301H4.10898V5.63337H0.42627V4.07757Z",
                    fill: "black"
                  }
                })
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "prices__wrapper" }, [
        _vm.product.attributes.is_on_sale
          ? _c("div", { staticClass: "cart-item-baseprice" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.product.attributes.base_price) +
                  " " +
                  _vm._s(_vm.currency) +
                  "\n            "
              )
            ])
          : _vm.product.attributes.is_on_promo
          ? _c("div", { staticClass: "cart-item-baseprice before-promo" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.product.attributes.price_original) +
                  " " +
                  _vm._s(_vm.currency) +
                  "\n            "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "cart-item-price" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.product.attributes.price) +
              " " +
              _vm._s(_vm.currency) +
              "\n            "
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }